SectionHome.EventTypes = Class(
	/**
	 * @lends {SectionHome.EventTypes#}
	 */
	{
		__NAME: 'SectionHome.EventTypes',

		__construct() {
			this.node = mkE({
				tag: 'div',
				className: 'home-event-types',
				els: [
					this._content = mkE({
						tag: 'div',
						className: 'container'
					})
				]
			});

			this.draw();
		},

		draw() {
			for (let i = 0; i < 4; i++) {
				let langKey = `home.event-types.urls.${i}`;
				if (D.Lang.get(langKey) === langKey) {
					continue;
				}
				new SectionHome.EventTypes.Item(i).append(this._content);
			}
		}
	},
	mkE.Base
);

SectionHome.EventTypes.Item = Class(
	/**
	 * @lends {SectionHome.EventTypes.Item#}
	 */
	{
		__NAME: 'SectionHome.EventTypes.Item',

		__construct(index) {
			this.index = index;

			this.node = mkE({
				tag: 'a',
				className: `home-event-types-item home-event-types-item-${this.index}`,
				href: D.url(D.Lang.get(`home.event-types.urls.${this.index}`)),
				els: [
					{
						tag: 'h2',
						className: 'h4',
						text: D.Lang.get(`home.event-types.titles.${this.index}`)
					}
				]
			});
		}
	},
	mkE.Base
);